import { useStepperContext } from "app/contexts/stepper";
import { useInscripcionContext } from "../../inscripcion-context";
import {
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  FormGroup,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { toast } from "react-hot-toast";
import { useState } from "react";
import { direccionWebRegex } from "app/utils/regexps";

const initialState = {
  pagina_web_url: "",
  pagina_web_principal: false,
};

function PaginaWebForm({ pagina_web = initialState }) {
  const { addPaginaWeb, updatePaginaWeb, deletePaginaWeb } =
    useInscripcionContext();

  const [state, setState] = useState(pagina_web);
  const [isEditable] = useState(!!pagina_web.pagina_web_id);
  const [isEditing, setEditing] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();

    try {
      if (!!isEditable && !isEditing) {
        return setEditing(true);
      } else if (!!isEditable && !!isEditing) {
        const isUpdated = updatePaginaWeb({
          pagina_web: state,
        });

        if (isUpdated) {
          setEditing(false);

          return toast.success("¡Dirección de página web actualizada!");
        }
      } else {
        const isAdded = addPaginaWeb({ pagina_web: state });

        if (isAdded) {
          setState(pagina_web);

          return toast.success("¡Dirección de página web agregada!");
        }
      }
    } catch (error) {
      console.log(error.message);

      return toast.error(error.message);
    }
  }

  function handleReset() {
    if (!!isEditable && !isEditing) {
      const isDeleted = deletePaginaWeb({
        pagina_web_id: pagina_web.pagina_web_id,
      });

      if (isDeleted) {
        return toast.success("¡Dirección de página web eliminada!");
      }
    } else if (!!isEditable && !!isEditing) {
      const isCanceled = window.confirm("¿Desea cancelar la edición?");

      if (isCanceled) {
        setState(pagina_web);

        return setEditing(false);
      }
    } else {
      const isReseted = window.confirm("¿Desea reiniciar el formulario?");

      if (isReseted) {
        setState(pagina_web);
      }
    }
  }

  return (
    <Paper
      component="form"
      className="animate__animated animate__slideInUp"
      onSubmit={handleSubmit}
      onReset={handleReset}
      variant="outlined"
    >
      <Grid container spacing={1} sx={{ padding: 2 }}>
        <Grid item xs={12}>
          <Typography variant="overline">
            <strong>{`${
              !!isEditable ? "Editar" : "Agregar"
            } dirección de página web`}</strong>
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <TextField
            type="text"
            label="Dirección de página web"
            value={state.pagina_web_url}
            onChange={(e) =>
              setState((state) => ({
                ...state,
                pagina_web_url: e.target.value,
              }))
            }
            inputProps={direccionWebRegex}
            size="small"
            fullWidth
            required
            disabled={!!isEditable && !isEditing}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormGroup>
            <FormControlLabel
              disabled={!!isEditable && !isEditing}
              control={
                <Checkbox
                  checked={state.pagina_web_principal}
                  onChange={(e) =>
                    setState((state) => ({
                      ...state,
                      pagina_web_principal: e.target.checked,
                    }))
                  }
                />
              }
              label="¿Es una dirección de página web principal?"
            />
          </FormGroup>
        </Grid>

        <Grid item xs={12} md={6}>
          <Stack direction="row" justifyContent="end" spacing={1}>
            <Button
              type="submit"
              variant="contained"
              size="small"
              color={!!isEditable ? "warning" : "success"}
            >
              {!!isEditable && !isEditing
                ? "Editar"
                : !!isEditing
                ? "Actualizar"
                : "Agregar"}
            </Button>

            <Button
              type="reset"
              variant="outlined"
              size="small"
              color={!!isEditable && !isEditing ? "error" : "inherit"}
            >
              {!!isEditable && !isEditing
                ? "Eliminar"
                : !!isEditing
                ? "Cancelar"
                : "Reiniciar"}
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
}

export function PaginasWeb() {
  const stepper = useStepperContext();
  const { empresa } = useInscripcionContext();

  function handleNext() {
    try {
      if (!empresa.paginas_web.length) {
        // throw new Error(
        //   "¡Por favor, agregue al menos una página web!"
        // );
      }

      return stepper.next();
    } catch (error) {
      return toast.error(error.message);
    }
  }

  return (
    <Stack spacing={2}>
      <Container maxWidth="sm">
        <Stack spacing={2}>
          {empresa.paginas_web.map((pagina_web) => (
            <PaginaWebForm
              key={pagina_web.pagina_web_id}
              pagina_web={pagina_web}
            />
          ))}

          <PaginaWebForm />
        </Stack>
      </Container>

      <Stack
        direction="row"
        justifyContent="end"
        alignItems="center"
        spacing={1}
      >
        {!stepper.isFirstStep && (
          <Button variant="outlined" size="small" onClick={stepper.back}>
            Atrás
          </Button>
        )}

        <Button variant="contained" size="small" onClick={handleNext}>
          Siguiente
        </Button>
      </Stack>
    </Stack>
  );
}
